<div class="container-fluid">
  <div class="row form-group"
    *ngIf="portal_details && portal_details.portalCompanyBanners && portal_details.portalCompanyBanners.length">
    <div class="col-md-12 p-0">
      <app-carousel [attachments]="portal_details.portalCompanyBanners"
        [storage_url]="'https://storage.googleapis.com/ezeone/icanrefer/'"></app-carousel>
    </div>
  </div>
</div>
<div class="container">
  <div class="row pt-3">
    <div class="col-md-12" *ngFor="let job of jobs">
      <div class="card">
        <div class="card-block p-3">
          <div class="row">
            <div class="col-md-10">
              <h5 class="card-title">{{job.productName}} <ng-container *ngIf="job.productCodeText">
                  ({{job.productCodeText}})
                </ng-container>
              </h5>
              <div *ngIf="job.sellerCompanyName" class="card-subtitle text-muted font-italic">
                <b>
                  <!-- <i class="fa fa-briefcase details-icon" aria-hidden="true"></i>
                   -->
                  <img src="assets/job-list/companyName.svg" class="details-icon">
                  <!-- <img src="assets/job-list/compensation.svg" class=""> -->
                </b>
                {{job.sellerCompanyName}}
              </div>
              <div class="card-text  p-y-1" *ngIf="job.statusHistory && job.statusHistory.length">

                <div class="details-flex">

                  <div class="job-card-notice-period">
                    <b>
                      <!-- <i class="fa fa-info-circle details-icon" aria-hidden="true"></i> -->
                      <img src="assets/job-list/status.svg" class="details-icon">
                      {{"Present Status"|translate}} :
                    </b>
                    {{job.statusHistory[job.statusHistory.length -1].stageTitle}} (
                    {{job.statusHistory[job.statusHistory.length
                    -1].statusTitle}})

                  </div>


                </div>


              </div>
            </div>

            <div class="col-md-2 text-right align-self-center">
              <button style="min-width: 7rem;" (click)="navigateToOnb()"
                class="blob-btn btn-sm btn   mx-1 tallite-action" type="submit">
                Proceed
                <i class="fa fa-angle-double-right ml-1" aria-hidden="true"></i>
                <span class="blob-btn__inner">
                  <span class="blob-btn__blobs">
                    <span class="blob-btn__blob"></span>
                    <span class="blob-btn__blob"></span>
                    <span class="blob-btn__blob"></span>
                    <span class="blob-btn__blob"></span>
                  </span>
                </span>
              </button>
            </div>



          </div>
          <div class="job-card-footer">
            Applied for {{job.productName}} on {{job.postedDate | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}}
          </div>

        </div>
      </div>
    </div>
    <div class="col-md-12" *ngIf="jobs && jobs.length ==0">
      <h6 class="text-center" *ngIf="fetching_jobs"> {{'EXTRA.no_applied_jobs'|translate}} </h6>
      <h6 class="text-center" *ngIf="!fetching_jobs"> <i class="fa fa-spinner fa-spin mx-2"></i>
        {{'EXTRA.fetching_applied_jobs'|translate}} </h6>
    </div>
  </div>
</div>